import site from '../site.json';

// Per-board feature switches (sites/<site>/site.json → "features"). New board features are tried on
// RefugeeJobLeads first (plan §0.3), then switched on for the other boards.
//   modernCards: the refreshed job card · savedJobs: save jobs on this device + /saved · shareJob: share/WhatsApp on job pages
export const feature = (name) => Boolean(site.features && site.features[name]);
